import { sanitizeDownloadFilename } from './downloadBlob';
import { resolveArenaWeeklyMediaLocale } from './gaisukeArenaMediaLocale';

export function parseFilenameFromContentDisposition(header?: string): string | null {
  if (!header) return null;
  const star = /filename\*=UTF-8''([^;\s]+)/i.exec(header);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1]);
    } catch {
      return star[1];
    }
  }
  const quoted = /filename="([^"]+)"/i.exec(header);
  if (quoted?.[1]) return quoted[1];
  const plain = /filename=([^;\s]+)/i.exec(header);
  return plain?.[1]?.replace(/^"|"$/g, '') ?? null;
}

export function gaisukeArenaVideoTitleForLocale(
  report: {
    videoTitleTelopJa?: string | null;
    videoTitleTelopEn?: string | null;
  },
  uiLanguage: string
): string | null {
  const locale = resolveArenaWeeklyMediaLocale(uiLanguage);
  if (locale === 'en') {
    return report.videoTitleTelopEn?.trim() || report.videoTitleTelopJa?.trim() || null;
  }
  return report.videoTitleTelopJa?.trim() || report.videoTitleTelopEn?.trim() || null;
}

export function buildGaisukeArenaVideoDownloadFilename(params: {
  titleTelop?: string | null;
  weekStartDate: string;
  weekEndDate: string;
  lang: string;
}): string {
  const loc = resolveArenaWeeklyMediaLocale(params.lang);
  const brand = loc === 'en' ? 'AI Trade Arena' : 'AIトレードアリーナ';
  const fallback = `${brand} ${params.weekStartDate}_${params.weekEndDate}`;
  let base = params.titleTelop?.trim() || fallback;
  base = base.replace(/[/\\?%*:|"<>]/g, '_').replace(/\s+/g, ' ').trim();
  if (base.length > 100) base = base.slice(0, 100).trim();
  const langSuffix = loc === 'en' ? ' (EN)' : '';
  return sanitizeDownloadFilename(`${base}${langSuffix}.mp4`);
}
